import { render, staticRenderFns } from "./SocialShareWidget.vue?vue&type=template&id=0229c6d0&"
import script from "./SocialShareWidget.vue?vue&type=script&lang=js&"
export * from "./SocialShareWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports